export const PublishFromQuery = {
  range: {
    publish_from: {
      lte: "now",
    },
  },
}

export const PublishToShouldQuery = [
  {
    range: {
      publish_to: {
        gt: "now",
      },
    },
  },
  {
    bool: {
      must_not: {
        exists: {
          field: "publish_to",
        },
      },
    },
  },
]

// 検索表示順の仕様: https://docs.google.com/spreadsheets/d/1Hh1M49TT8sJRGC0i6X5rvPWk296CGsKNhIbtDx4p7Hk/edit#gid=215472697&range=L29
export const PokemonSingleDefaultSort = [
  { "pm_card.series.created_at": { order: "desc" } },
  { "pm_card.pack.released_at": { order: "desc" } },
  { "pm_card.pack.created_at": { order: "asc" } },
  { "pm_card.rarity.rarity_sort": { order: "asc" } },
  { "pm_card.collection_number": { order: "asc" } },
  { created_at: { order: "asc" } },
]

// 在庫が存在するinventoryの最安値で昇順ソート
export const LowestAvailablePriceSort = {
  _script: {
    type: "number",
    script: {
      source: `
        def minPrice = Double.MAX_VALUE;
        for (field in ['rank_s_inventory', 'rank_a_inventory', 'rank_b_inventory', 'rank_c_inventory']) {
          if (params['_source'].containsKey(field)) {
            def inventory = params['_source'][field];
            if (inventory.inventory_num > 0) {
              if (inventory.selling_price < minPrice) {
                minPrice = inventory.selling_price;
              }
            }
          }
        }
        return minPrice;
      `,
      params: {}
    },
    order: "asc"
  }
}
